import React from "react";

const Button = ({ text }) => {
  return (
    <button className="relative w-28 h-10 text-white text-lg font-bold bg-black border-2 border-transparent rounded-lg overflow-hidden transition-all duration-500 group hover:border-orange-500">
      {/* Hover Effect Background */}
      <span className="absolute inset-0 bg-white transform -skew-x-45 scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></span>

      {/* Text Change Based on Props */}
      <span className="absolute inset-0 flex items-center justify-center text-white group-hover:text-black transition-colors duration-500">
        {text}
      </span>
    </button>
  );
};

export default Button;
